module.exports = __webpack_public_path__ + "assets/img/login_banner.baf18520.png";